import { styled } from '@abyss/web/tools/styled';
import { Button } from '@abyss/web/ui/Button';
import { SelectInput } from '@abyss/web/ui/SelectInput';
import { TextInput } from '@abyss/web/ui/TextInput';

import { ERROR_COLOR } from './constants';

export const DeeplinkFormStyledSelectInput = styled(SelectInput, {
  marginBottom: '2px',
  '.abyss-select-input-label': {
    color: '$gray8',
    fontWeight: 600,
    marginBottom: '8px',
  },
  '.abyss-select-input-input-container': {
    height: '40px',
  },
  '.abyss-select-input-input': {
    paddingLeft: '12px !important',
    fontSize: '14px !important',
    textAlign: 'left',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
  },
  '.abyss-select-input-option-list': {
    maxHeight: '288px',
  },
  '.abyss-select-input-option': {
    padding: '12px',
    fontSize: '16px',
    fontWeight: 400,
  },
  '.abyss-select-input-icon-container': {
    border: 'none !important',
    outline: 'none !important',
  },
  '.abyss-select-input-icon-container:focus': {
    border: 'none !important',
    outline: 'none !important',
  },
  '& .abyss-select-input-descriptors': {
    marginTop: '6px !important',
    fontSize: '14px !important',
    color: ERROR_COLOR,
  },
  '& .abyss-select-input-descriptors > span': {
    color: ERROR_COLOR,
  },
  '&& .abyss-select-input-descriptors span': {
    color: ERROR_COLOR,
  },
  '&&& .abyss-select-input-descriptors *': {
    color: ERROR_COLOR,
  },
  '& [class*="abyss-select-input-descriptors"] span': {
    color: ERROR_COLOR,
  },
});

export const DeeplinkFormStyledTextInput = styled(TextInput, {
  marginBottom: '2px',
  '.abyss-text-input-label': {
    color: '$gray8',
    fontWeight: 600,
    marginBottom: '8px',
  },
  '.abyss-text-input': {
    paddingLeft: '12px',
    fontSize: '14px',
  },
  '&::placeholder': {
    color: '$gray5',
    fontSize: '14px',
  },
  '& .abyss-text-input-descriptors': {
    marginTop: '6px !important',
    fontSize: '14px !important',
    color: ERROR_COLOR,
  },
  '& .abyss-text-input-descriptors > span': {
    color: ERROR_COLOR,
  },
  '&& .abyss-text-input-descriptors span': {
    color: ERROR_COLOR,
  },
  '&&& .abyss-text-input-descriptors *': {
    color: ERROR_COLOR,
  },
  '& [class*="abyss-text-input-descriptors"] span': {
    color: ERROR_COLOR,
  },
});
export const DeeplinkFormDemoProviderSearchContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  fontFamily: '$primary',
  backgroundColor: '$bgHeaderColor',
  paddingTop: '1em',
  paddingBottom: '1.1em',
  borderRadius: 0,
  '@screen < $md': {
    marginRight: '16px',
    borderRadius: '20px 20px 0px 0px',
    width: '100%',
  },
});
export const GuestTokenFormContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  fontFamily: '$primary',
  backgroundColor: '$bgHeaderColor',
  paddingTop: '1em',
  paddingBottom: '1.1em',
  marginRight: '24px',
  '@screen < $md': {
    marginRight: '16px',
  },
});

export const UrlDisplayContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  marginTop: '24px',
  padding: '12px',
  backgroundColor: '$gray1',
  borderRadius: '8px',
  width: '100%',
});

export const UrlRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const UrlLabel = styled('span', {
  fontWeight: 600,
  color: '$gray8',
  minWidth: '60px',
});

export const UrlText = styled('input', {
  flex: 1,
  padding: '8px 12px',
  border: '1px solid $gray3',
  borderRadius: '4px',
  fontSize: '12px',
  fontFamily: 'monospace',
  backgroundColor: '$white',
  color: '$gray7',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const StyledButton = styled(Button, {
  variants: {
    variant: {
      solid: {
        '&.abyss-button-root': {
          '&:hover': {
            color: '$white',
          },
        },
      },
    },
  },
});

export const CopyButton = styled(Button, {
  minWidth: '80px',
  variants: {
    variant: {
      solid: {
        '&.abyss-button-root': {
          '&:hover': {
            color: '$white',
          },
        },
      },
    },
  },
});

export const ButtonContainer = styled('div', {
  display: 'flex',
  gap: '10px',
  width: '100%',
  marginTop: '4px',
});
